import { route } from "@/router/route";
import { menu } from "@/constants/menu";

// homeLink 접두사(백엔드 내부 식별자)를 프론트엔드 라우트 섹션명으로 매핑
const homelinkSectionMap = {
  "intro": "intro",
  "curriculum": "curriculum",
  "support": "support",
  "out-come": "sharing",
  "square": "plaza",
};

/**
 * API 응답 content 배열에서 특정 섹션을 영문 link 키로 찾는다.
 * 한글 타이틀 비교는 menu 상수 한 곳에서만 처리한다.
 * @param {Array} content - API 응답의 content 배열
 * @param {string} link - 섹션 link 키 (예: 'intro', 'curriculum')
 */
export function findMenuSection(content, link) {
  const config = menu.find((m) => m.link === link);
  if (!config) return null;
  return content.find((m) => m.title === config.title) || null;
}

/**
 * 백엔드 homeLink 값 (예: "/intro1", "/curriculum02", "/square3") 으로
 * 프론트엔드 라우트 경로를 반환한다.
 * 서브메뉴가 미사용 처리돼 배열에서 빠져도 올바른 경로를 유지한다.
 */
export function getRouteByHomeLink(homeLink) {
  if (!homeLink) return null;
  const path = homeLink.replace(/^\//, "");
  const match = path.match(/^([a-z-]+?)(\d+)$/i);
  if (!match) return null;
  const section = homelinkSectionMap[match[1].toLowerCase()] || match[1].toLowerCase();
  const routeKey = `${section}${Number(match[2])}`;
  return route[routeKey] || null;
}
